export default __webpack_public_path__ + "static/media/jpg.fab39bdf.svg";